











































































































































































































































































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import {  Watch } from 'vue-property-decorator';
import { Prop } from 'vue-property-decorator';
import { DxButton, DxDateBox, DxPopup, DxLookup, DxSelectBox, DxTagBox, DxTextBox, DxCheckBox, DxScrollView } from 'devextreme-vue';
import { DxList } from 'devextreme-vue/list';
import DxToolbar from 'devextreme-vue/toolbar';
import { DxForm, DxItem, DxAsyncRule, DxStringLengthRule, DxSimpleItem} from 'devextreme-vue/form';
import CustomStore from 'devextreme/data/custom_store';
import { AgentService } from '../../service/AgentService';
import { FilingTypeService } from '@/service/FilingTypeService';
import { ClientDto } from '@/models/client/ClientDto';
import { FeeSheetDto } from '@/models/Fees/FeeSheetDto';
import { DxToolbarItem } from 'devextreme-vue/popup';
import { FilingTypeDto } from '@/models/FilingTypeDto';
import { CurrencyService } from '@/service/CurrencyService';
import { JurisdictionDto } from '@/models/JurisdictionDto';
import { alert } from 'devextreme/ui/dialog';
import Form from 'devextreme/ui/form';
import { FeeSheetsService } from '@/service/FeeSheetsService';
import { FeeSheetModalFor, FeeSheetModalType } from '@/models/Fees/FeeTypeEnum';
import _ from 'lodash';
import { InfractionService } from '@/service/InfractionService';
import { PhaseTypeService } from '@/service/PhaseTypeService';
import { DataGrid } from '@questelservices/common-vue';
import  FeeSheetRowDialog  from './fee-sheet-row-dialog.vue';
import { DxHtmlEditor } from 'devextreme-vue/html-editor';
import { DxDataGrid, DxColumn, DxEditing, DxHeaderFilter } from 'devextreme-vue/data-grid';
import DevExpress from 'devextreme';
import { PhaseTypeDto } from '@/models/PhaseTypeDto';
import { FeeSheetRowDto, FeeSheetRowTypeEnum, FeeSheetRowStatusEnum, FeeSheetRowDetailEnum } from '../../models/Fees/FeeSheetRowDto';
import { FeeSheetRuleDto, FeeSheetRuleTypeEnum, FeeSheetRuleLevelEnum, FeeSheetRulesSortFunction, FeeSheetRuleLevelNameEnum } from '@/models/Fees/FeeSheetRuleDto';
import { CountryDto } from '@/models/CountryDto';
import { CountryService } from '@/service/CountryService';
import { FileService } from '@/service/FileService';
import DxValidator, { DxRequiredRule } from 'devextreme-vue/validator';
import { InfractionTypeDto } from '@/models/infractions/InfractionTypeDto';
import { Popup } from '@questelservices/common-vue';
import { ClientService } from '@/service/ClientService';
import { AgentDto } from '@/models/agent/AgentDto';
import { FeeSheetTemplateDto } from '@/models/FeeSheetTemplates/FeeSheetTemplateDto';
import dialog from 'devextreme/ui/dialog';
import notify from 'devextreme/ui/notify';
import { DxLoadPanel } from 'devextreme-vue/load-panel';
import FeeSheetRowNotes from './fee-sheet-row-notes.vue'
import ParentFeeSheetRowDetails from  './parent-fee-sheet-row-details.vue';

const moment = require('moment');

const JURISDICTION : JurisdictionDto[] = [
        { Name : "In", Value : true},
        { Name : "Out", Value : false}
    ]

@Component({
  components: {
    Popup,
    DxForm,
    DxItem,
    DxButton,
    DxDateBox,
    DxList,
    DxLookup,
    DxSelectBox,
    DxTagBox,
    DxToolbar,
    DxToolbarItem,
    DxStringLengthRule,
    DxAsyncRule,
    DxSimpleItem,
    DataGrid,
    DxColumn,
    DxHeaderFilter,
    DxEditing,
    DxDataGrid,
    FeeSheetRowDialog,
    DxHtmlEditor,
    DxCheckBox,
    DxTextBox,
    DxValidator,
    DxRequiredRule,
    DxScrollView,
    FeeSheetRowNotes,
    ParentFeeSheetRowDetails,
    DxLoadPanel
  }
})
export default class AddUpdateFeeSheets extends Vue {
    $refs: Vue['$refs'] & {
        formComponent?: Form;
        phaseDataGrid?: DataGrid;
        infractionDataGrid?: DataGrid;
        refFeeSheetName?:any;    
    } = {};

    @Prop({ default: FeeSheetModalFor.Client })
    feeSheetFor! : FeeSheetModalFor

    @Prop({ default: FeeSheetModalType.Add })
    feeSheetType! : FeeSheetModalType

    @Prop({ default: function() { 
        let def : FeeSheetDto = {
            FeeSheetId: "00000000-0000-0000-0000-000000000000",
            ClientId: "",
            AgentId: "",
            CurrencyId: 1,
            InJurisdiction: true,
            FeeSheetName: "",
            EffectiveDate: new Date(),
            FilingTypes: [-1],
            FilingTypesNamesString: "",
            FeeSheetRows: [],
            FeeSheetTitle: "",
            DeletedFeeSheetRows: [],
            Signed: "",
            Modified: false,
            ReceiptFileId: null,
            ReceiptFileName: null            
        };
        return def;        
     } })
    feeSheet! : FeeSheetDto;   

    get feeSheetValue() {        
        return this.feeSheet;
    }

    @Prop()
    client!: ClientDto;

    @Prop({ default: false })
    showDialog!: boolean;

    @Prop()
    template: FeeSheetTemplateDto | undefined;

    get showingDialog() {
        return this.showDialog;
    }

    set showingDialog(value:boolean) {
        this.hidingModal();
    }

    get ThisFeeSheetType() {
        return this.feeSheetType;
    }

    set ThisFeeSheetType(value: FeeSheetModalType) {
        this.feeSheetType = value;
    }  

    @Watch("showDialog")
    async onShowPropChange(value: boolean, oldValue: boolean) {                
        if(value){ 
            this.processClientVal();
            this.processGetCountries()
                .then(result => {                
                    this.processFeeSheetVal(); 
                });
            this.processAgentValidation();
            this.processFeeSheetType();                  
        }
    }

    private get dxPhaseDataGrid(): DevExpress.ui.dxDataGrid {
        return (this.$refs.phaseDataGrid as any).$refs.dxDataGrid.instance;
    }    

    get ClientVal() {
        return this.client;
    }

    private get dxForm() {
        return ((this.$refs.formComponent as Form).instance as any); 
    }

    private showSentDateListPopup: boolean = false;
    
    parentFeeSheetRows: Array<FeeSheetRowDto> = [];
    phaseWatcher: any;
    infractionWatcher: any;
    async getPrentFeeSheetDetails(id: Guid) {
        return await this.feeSheetsService.getParentFeeSheetDetails(id)
                .then(success => {
                    _.forEach(success, (item : FeeSheetRowDto) => {
                        item.CapDisplay = '';
                        this.processCapDisplay(item, true);
                    });

                    return success;
                })
                .catch(err => []);
    }

    async processGettingFeeSheetRows(id: Guid) {
        if (this.$refs.phaseDataGrid) {
            (this.$refs.phaseDataGrid as any).instance.beginCustomLoading('');
        }

        if (this.$refs.infractionDataGrid) {
            (this.$refs.infractionDataGrid as any).instance.beginCustomLoading('');
        }

        this.PhaseFeeSheetRows = await this.processFeeSheetRows(id, FeeSheetRowTypeEnum.Phase)
            .then((success: FeeSheetRowDto[]) => {
                let result = _.forEach(success, (item: FeeSheetRowDto) => {
                    _.forEach(item.FeeSheetRules, (fr: FeeSheetRuleDto) => {
                        if(!fr.CountryId) {
                            fr.CountryId = 0;
                        }
                    })
                });
                
                return result;
            })
            .catch(err=> [])
            .finally(() => {
                (this.$refs.phaseDataGrid as any).instance.endCustomLoading();
            });

        this.InfractionFeeSheetRows = await this.processFeeSheetRows(id, FeeSheetRowTypeEnum.Infraction)
            .then((success: FeeSheetRowDto[]) => {
                let result = _.forEach(success, (item: FeeSheetRowDto) => {
                    _.forEach(item.FeeSheetRules, (fr: FeeSheetRuleDto) => {
                        if(!fr.CountryId) {
                            fr.CountryId = 0;
                        }
                    })
                });
                
                return result;
            })        
            .catch(err=>[])
            .finally(() => {
                (this.$refs.infractionDataGrid as any).instance.endCustomLoading();
            });      
    }

    dialogTitle: string = "";
    filingTypeValue: any = "";    

    get thisIsClientFor() {
        return this.isClientFor;
    }
    set thisIsClientFor(value: boolean) {
        this.isClientFor = value;
    }

    private agentService : AgentService = new AgentService();
    private clientService: ClientService;
    private currencyService : CurrencyService;
    private filingTypeService: FilingTypeService;
    private feeSheetsService: FeeSheetsService;
    private infractionService: InfractionService;
    private phaseService: PhaseTypeService;
    private countryService: CountryService;
    showParentFeeSheetRowDetail: boolean = false;
    parentFeeSheetRowToView: any = {};
    private fileService: FileService;
    selectedToBeAddPhaseType: any = {};
    countryList: CountryDto[] = [];
    selectedAgent: Guid = '';
    feeSheetStore: CustomStore;
    isClientFor: boolean = true
    isAgentFor: boolean = false;
    isAgentForUpdate: boolean = false;
    showFeeSheetRowDialog: boolean;
    feeSheetRow: FeeSheetRowDto;
    feeSheetRowModalType : FeeSheetModalType = FeeSheetModalType.Add;
    feeSheetRowIndex: number | undefined;
    selectedSheetNameFeeSheetId: Guid = '';
    PhaseFeeSheetRows : Array<FeeSheetRowDto> = [];
    InfractionFeeSheetRows : Array<FeeSheetRowDto> = [];
    private feeSheetRowType : FeeSheetRowTypeEnum = FeeSheetRowTypeEnum.Phase;
    SavedCurrentFeeSheetName: string = '';
    selectedPhasesInfraction: (Guid | number)[] = [];
    private agents: AgentDto[] = [];
    titleItemGroup: any = ['FeeSheetTitle'];
    showFeeSheetNotes: boolean = false;
    selectedfeeSheetRowNotes: FeeSheetRowDto | null = null;
    private originalFileId?: string | null = null;
    private originalFileName?: string | null = null;
    private selectedFile?: any;
    private isLoading: boolean = false;

    filingStore: CustomStore = new CustomStore({
        loadMode: 'raw',
        load: (options): Promise<any> => {
        return this.filingTypeService.getTypes()
            .then((success: FilingTypeDto[]) => {
                let all : FilingTypeDto = {
                    FilingTypeId: -1,
                    Name: "All"
                }

                success.unshift(all);
                return success;
            })
            .catch(err => {
                return [];
            });
            
        }
    });

    currencyStore: CustomStore = new CustomStore({
        loadMode: 'raw',
        load: (options): Promise<any> => {
            return this.currencyService.getAll()
        }
    });

    phaseTypeStore: CustomStore = new CustomStore({
        loadMode: 'raw',
        load: (options): Promise<any> => {
            return this.phaseService.getAll()
        }
    });

    private feeSheetCustomStore(): CustomStore {
        return new CustomStore({
            loadMode: 'raw',
            load: (options): Promise<any> => {
                return this.feeSheetsService.getFeeSheetPerClient(this.getClientIdVal())
                    .then((response: FeeSheetDto[]) => {                                           
                        _.forEach(response, (item: FeeSheetDto) => {
                            if(item.FilingTypes.length == 0) {
                                item.FilingTypes = [-1];
                            }
                        });

                        return response;
                    })
                    .catch(err => {
                        return [];
                    });
            }
        })
    }

    constructor() {
        super();
        this.showFeeSheetRowDialog = false;
        this.feeSheetStore = this.feeSheetCustomStore();        
        this.clientService = new ClientService();
        this.filingTypeService = new FilingTypeService();
        this.currencyService = new CurrencyService();
        this.infractionService = new InfractionService();
        this.countryService = new CountryService();
        this.fileService = new FileService();
        this.phaseService = new PhaseTypeService();        
        this.feeSheetsService = new FeeSheetsService('/api/FeeSheets');        
        this.feeSheetRow = this.feeSheetRowDefaultValue();      
        this.showSentDateListPopup = false;           
    } 

    protected mounted(): void {
        this.loadData();
    }

    private async loadData(): Promise<void> {
        this.agentService = new AgentService();
        this.agents = await this.agentService.getAll(this.client.ClientId);
    }

    jurisdictionOption: any = {
        "items" : JURISDICTION,
        "displayExpr": "Name",
        "valueExpr": "Value",
    }

    feeSheetOption: any = {
        "placeholder" : "Select client fee sheet",
        "dataSource" : this.feeSheetStore,
        "displayExpr": "FeeSheetName",
        "valueExpr": "FeeSheetName",
        "onSelectionChanged": this.onFeeSheetSelectionChanged,
        "visible" : true
    }

    feeSheetTextBoxOption: any = {
        "visible": true,
        "maxLength": 150
    }

    get agentOption(): any {
      return {
        "placeholder" : "Select an agent",
        "dataSource" : this.agents,
        "displayExpr": "AgentName",
        "valueExpr": "AgentId",
        "popupHeight": this.getPopupHeight,
        "searchEnabled": true,
        "showClearButton":true,
        "showCancelButton": true,
        "onSelectionChanged": this.onFeeSheetAgentSelectionChanged
      };
    }

    filingOption: any = {
        "displayExpr": "Name",
        "valueExpr": "FilingTypeId",
        "placeholder" : "Select filing type",
        "dataSource" : this.filingStore,
        "showSelectionControls" : true,        
        "applyValueMode" : 'useButtons',
        "multiline" : false
    }

    currencyOption: any = {
        "displayExpr": "CurrencyCode",
        "valueExpr": "CurrencyId",
        "placeholder" : "Select currency",
        "dataSource" : this.currencyStore,
    }

    private sentDates: Date[] = [];

    private async openSentDatePopup(data: any) {        
        this.showSentDateListPopup = true;
        this.sentDates = await this.feeSheetsService.getSentDates(this.feeSheetValue.FeeSheetId);        
    }

    private formatSentDates(item: Date) {        
        let data = moment(item).format("MM-DD-YYYY");        
        return data;
    }

    private closePopup(): void {
        this.showSentDateListPopup = false;
    }

    titleOptions: any = {
      "maxLength": 150
    };

    effectiveDateOptions: any = {
      "openOnFieldClick": true
    };

    validationRules: any = {
        jurisdiction: [
            {type: 'required', message: 'Jurisdiction is required.'}
        ],
        filingType :  [
            {type: 'required', message: 'Filing Type is required.'},
            {
                type: 'custom', 
                message: 'If \'All\' is selected, it must be the only filing type selected.', 
                validationCallback: this.validateFilingType                
            }
        ],
        currency :  [
            {type: 'required', message: 'Currency is required.'}
        ],
        agent : [
            { type: 'required', message: 'Agent is required.' }
        ],
        sheetName: [
            {type: 'required', message: 'Sheet Name is required.'}
        ],
        sheetTitle: [
             {type: 'required', message: 'Title is required.'}
        ]
    }

    notSelectedManually: boolean = true;
    feeSheetNameValidator: any;
    async asyncValidation(params: any)  {
        let currentFeeSheetNameVal = this.SavedCurrentFeeSheetName;
        this.feeSheetNameValidator = params.validator;
        
        if(this.thisIsClientFor) {
            return await this.feeSheetsService.checkFeeSheetName(params.value, this.ClientVal.ClientId)
                .then(response => {
                    if(response) {
                        if(currentFeeSheetNameVal &&
                            currentFeeSheetNameVal === params.value) {
                            return true;
                        }

                        return false;
                    }
                    else {
                        return true;
                    }
                })
                .catch(err => {
                    return true
                    });
        }
        else {
            if(!this.feeSheet.AgentId) {
                return Promise.resolve(true);
            }

            if(!this.notSelectedManually) {
                this.processValidation(this.agentValidator);
            }
            
            return await this.feeSheetsService.checkFeeSheetName(params.value,this.ClientVal.ClientId, this.feeSheet.AgentId)
                .then(response => {
                    return false;
                })
                .catch(err => {return true})
                .finally(() => {
                    this.notSelectedManually = true;
                });
        }
    }

    agentValidator: any;
    async asyncValidationAgent(params: any) {

        this.agentValidator = params.validator;
        await this.processValidation(this.feeSheetNameValidator);

        if(!this.feeSheet.FeeSheetName) {
            return true;
        }

        return await this.feeSheetsService.checkFeeSheetName(this.feeSheet.FeeSheetName,this.ClientVal.ClientId,params.value)
        .then(response => {
            return false;
         })
        .catch(err => {return true})
        .finally(() => {
            this.notSelectedManually = true;
        });
    }

    async processValidation(otherValidator: any) {
        return await new Promise((resolve, reject) => {
            if(this.validationForm) {
                if(otherValidator) {
                    let vldtr = _.find(this.validationForm.validators, item => 
                        !item.option().isValid && 
                        item == otherValidator
                    )
                  
                    this.notSelectedManually = true;
                    if(vldtr) {
                        vldtr.validate();
                    }
                }    
            }
            resolve();
        }) 
    }

    validateFilingType(e: any) {
        // If All is selected, it must the only option selected
        return !e.value.includes(-1) || e.value.length == 1;
    }

    getClientIdVal() : string {
        return this.client.ClientId;
    }

    feeSheetRowDefaultValue() : FeeSheetRowDto {
        let def: FeeSheetRowDto = {
            FeeSheetRowId: "00000000-0000-0000-0000-000000000000",
            FeeSheetId: this.feeSheet ? this.feeSheet.FeeSheetId:
                "00000000-0000-0000-0000-000000000000",
            Description: "",
            Signed: false,
            FeeSheetRules: [],
            CapDisplay : "",
            UserNotes: null,
            UserNotesUpdateDate: null,
            UserNotesUpdatedBy: null
        }

        return _.clone(def); 
    }

    private feeSheetDefaultValue() : FeeSheetDto {
        let def : FeeSheetDto = {
            FeeSheetId: "00000000-0000-0000-0000-000000000000",
            ClientId: "",
            AgentId: "",
            CurrencyId: 1,
            InJurisdiction: true,
            FeeSheetName: "",
            EffectiveDate: new Date(),
            FilingTypes: [-1],
            FilingTypesNamesString: "",
            FeeSheetRows: [],
            FeeSheetTitle: "",
            DeletedFeeSheetRows: [],
            Signed: "",
            Modified: false,
            ReceiptFileId: null,
            ReceiptFileName: null            
        };

        return _.clone(def); 
    }

    getPopupHeight(): number {
        return window.innerHeight / 2;
    }
    async onPopupShown(e:any)  {
        if(this.feeSheet.FeeSheetId
            && this.feeSheet.FeeSheetId != this.feeSheetDefaultValue().FeeSheetId
        ) {
            let id = this.feeSheet.FeeSheetId;
            if(this.feeSheetFor === FeeSheetModalFor.Agent) {
                this.parentFeeSheetRows = await this.getPrentFeeSheetDetails(id);
            }
            await this.processGettingFeeSheetRows(id);
        }
        else {  
            if(this.template == null) {
                this.feeSheet.FeeSheetRows = [];
                this.PhaseFeeSheetRows = [];
                this.InfractionFeeSheetRows = [];
            }            
        }
    }

    onPopupHidden(e:any) : void {
        this.isClientFor = true;
        this.isAgentFor = false;
        this.isAgentForUpdate = false;
        this.PhaseFeeSheetRows = [];
        this.InfractionFeeSheetRows = [];
        this.originalFileId = null;
        this.originalFileName = null;
        this.selectedFile = null;
        this.SavedCurrentFeeSheetName = '';
        this.dxForm.resetValues();
        if(this.phaseWatcher){
            this.phaseWatcher();
        }
        if(this.infractionWatcher) {
            this.infractionWatcher();
        }
    }

    processFeeSheetType(): any{
        this.feeSheetOption.readOnly = false;
        this.agentOption.readOnly = false;
        this.jurisdictionOption.readOnly = false;
        this.filingOption.readOnly = false;
        this.currencyOption.readOnly = false;
        this.titleOptions.readOnly = false;

        if (this.isClientFor) {
            this.agentOption.readOnly = true;
        } else {
            this.jurisdictionOption.readOnly = true;
            this.filingOption.readOnly = true;
            this.currencyOption.readOnly = true;
            this.titleOptions.readOnly = true;

            if (this.ThisFeeSheetType === FeeSheetModalType.Update) {
                this.feeSheetOption.readOnly = true;
                this.agentOption.readOnly = true;
            } else {
                this.validationRules.sheetName.push(
                        {type: 'async', validationCallback:this.asyncValidation,
                        message:'This fee sheet already exists for this agent.'
                    }
                )

                this.validationRules.agent.push( 
                        {type: 'async', validationCallback:this.asyncValidationAgent,
                        message:'Already has this fee sheet record.'
                    }
                );
            }
        }
    }

     async processGetCountries() {
        this.countryList = await this.countryService.getAllDto().then((responses: CountryDto[]) => {
            let forAll : CountryDto = {
                CountryId: 0,
                CountryCode: "All"
            }

            responses.unshift(forAll);

            return responses;
        });
    }

    processAgentValidation() : void {        
        if(this.feeSheetFor != FeeSheetModalFor.Agent) {
            this.isClientFor = true;
            this.isAgentFor = false;
            this.agentOption.readOnly = true;
            this.validationRules.agent = [];
            this.validationRules.sheetName = [
                {type: 'required', message: 'Sheet Name is required.'},
                {type: 'async', validationCallback:this.asyncValidation,
                    message:'Sheet Name already exists.'
                }
            ];
            
        }
        else {            
            this.feeSheetOption.dataSource = this.feeSheetStore;
            this.isClientFor = false;
            this.isAgentFor = true;
            this.feeSheetStore = this.feeSheetCustomStore();
            this.agentOption.readOnly = false;
            this.validationRules.agent = [
                { type: 'required', message: 'Agent is required.' }
            ];
            this.validationRules.sheetName = [
                {type: 'required', message: 'Sheet Name is required.'}
                
            ]
        }
        this.feeSheetTextBoxOption.visible = this.isClientFor;
        this.feeSheetOption.visible = !this.isClientFor;        
    }

    processClientVal(): void {
        if(this.client) {
            this.feeSheet.ClientId = this.client.ClientId;
        }
    }    

    processFeeSheetVal()  {        
        if(this.feeSheet.FeeSheetId
            && this.feeSheet.FeeSheetId != this.feeSheetDefaultValue().FeeSheetId
        ) {            
            this.dialogTitle = `Update ${this.feeSheetFor} Fee Sheet`;
            if(this.$refs.formComponent) {
                (this.$refs.formComponent as any).formData.EffectiveDate = this.feeSheet.EffectiveDate;
            }                
            this.SavedCurrentFeeSheetName = _.clone(this.feeSheet.FeeSheetName);

            if (this.feeSheet.FilingTypes.length == 0) {
                this.feeSheet.FilingTypes = [-1];
            }

            this.dialogTitle = `Update ${this.feeSheetFor} Fee Sheet`            
            this.SavedCurrentFeeSheetName = _.clone(this.feeSheet.FeeSheetName);            
            this.originalFileId = this.feeSheet.ReceiptFileId;

        }
        else {
            this.feeSheet = this.feeSheetDefaultValue();                        
            if(this.template != null) {                
                this.feeSheet.FeeSheetName = this.template.TemplateName;
                this.feeSheet.InJurisdiction = this.template.InJurisdiction;

                this.template.FeeSheetTemplatePhases.forEach(p => {
                    let phaseType: PhaseTypeDto = {
                        PhaseTypeId: p.PhaseTypeId != undefined ? p.PhaseTypeId : 0,
                        PhaseName: p.PhaseName != undefined ? p.PhaseName : "",
                        RgbHex: "",
                        PhaseVerb: "",
                        PhaseOrder: 0,
                        SecondaryPhaseOrder: 0,
                        IsBatched: false
                    }


                    let phaseRow = this.feeSheetRowDefaultValue();
                    phaseRow.PhaseTypeId = p.PhaseTypeId;
                    phaseRow.PhaseType = phaseType;
                    phaseRow.Description = p.Description;   
                    
                    p.FeeSheetTemplateRules.forEach(r => {
                        if(r.CapAmount != undefined) {
                            let phaseRule: FeeSheetRuleDto = {
                                FeeSheetRuleId: '00000000-0000-0000-0000-000000000000',
                                FeeSheetRowId: phaseRow.FeeSheetRowId,
                                CountryId: r.CountryId === null ? 0 : r.CountryId,
                                CurrencyId: 0,
                                CapAmount: r.CapAmount,
                                Notes: r.Notes,
                                Level: r.Level,
                                Type: r.Type,
                                Amount: r.Amount,
                                CountryCode: r.CountryCode,
                                Signed: false,
                                InJurisdiction: false,
                                FilingTypes: []                                                    
                            };
                            phaseRow.FeeSheetRules.push(phaseRule);
                        }

                        if(r.TargetAmount != undefined) {
                            let phaseRule: FeeSheetRuleDto = {
                                FeeSheetRuleId: '00000000-0000-0000-0000-000000000000',
                                FeeSheetRowId: phaseRow.FeeSheetRowId,
                                CountryId: r.CountryId === null ? 0 : r.CountryId,
                                CurrencyId: 0,
                                TargetAmount: r.TargetAmount,
                                Notes: r.Notes,
                                Level: r.Level,
                                Type: r.Type,
                                Amount: r.Amount,
                                CountryCode: r.CountryCode,
                                Signed: false,
                                InJurisdiction: false,
                                FilingTypes: []                                                    
                            };
                            phaseRow.FeeSheetRules.push(phaseRule);
                        }                        
                    });
                    this.processCapDisplay(phaseRow);
                    this.PhaseFeeSheetRows.push(phaseRow);
                });

                this.template.FeeSheetTemplateTasks.forEach(t => {
                    let infractionType: InfractionTypeDto = {
                        InfractionTypeId: t.InfractionTypeId,
                        Name: t.InfractionName != undefined ? t.InfractionName : "",
                        IsConfirmed: false
                    }

                    let infractionRow = this.feeSheetRowDefaultValue();
                    infractionRow.InfractionTypeId = t.InfractionTypeId;
                    infractionRow.InfractionType = infractionType;
                    infractionRow.Description = t.Description;

                    t.FeeSheetTemplateRules.forEach(r => {
                        if(r.CapAmount != undefined) {
                            let infractionRule: FeeSheetRuleDto = {
                                FeeSheetRuleId: '00000000-0000-0000-0000-000000000000',
                                FeeSheetRowId: infractionRow.FeeSheetRowId,
                                CountryId: r.CountryId === null ? 0 : r.CountryId,
                                CurrencyId: 0,
                                CapAmount: r.CapAmount,
                                Notes: r.Notes,
                                Level: r.Level,
                                Type: r.Type,
                                Amount: r.Amount,
                                CountryCode: r.CountryCode,
                                Signed: false,
                                InJurisdiction: false,
                                FilingTypes: []                                                      
                            };
                            infractionRow.FeeSheetRules.push(infractionRule);
                        }

                        if(r.TargetAmount != undefined) {
                            let infractionRule: FeeSheetRuleDto = {
                                FeeSheetRuleId: '00000000-0000-0000-0000-000000000000',
                                FeeSheetRowId: infractionRow.FeeSheetRowId,
                                CountryId: r.CountryId === null ? 0 : r.CountryId,
                                CurrencyId: 0,
                                TargetAmount: r.TargetAmount,
                                Notes: r.Notes,
                                Level: r.Level,
                                Type: r.Type,
                                Amount: r.Amount,
                                CountryCode: r.CountryCode,
                                Signed: false,
                                InJurisdiction: false,
                                FilingTypes: []                                                        
                            };
                            infractionRow.FeeSheetRules.push(infractionRule);
                        }
                        
                    });

                    this.processCapDisplay(infractionRow);
                    this.InfractionFeeSheetRows.push(infractionRow);                    
                });                
            }                       

            this.feeSheet.ClientId = this.client.ClientId;
            this.dialogTitle = `Add ${this.feeSheetFor} Fee Sheet`
        }        
    }

    async processFeeSheetRows(id: Guid, type?: FeeSheetRowTypeEnum): Promise<FeeSheetRowDto[]> {
        return await this.feeSheetsService.searchFeeSheetDetailsPerFeeSheetId(id, type).then(
            (response : FeeSheetRowDto[]) => {
                _.forEach(response, (item : FeeSheetRowDto) => {
                    item.CapDisplay = '';
                    this.processCapDisplay(item);
                });

                return response;
            }
        )
        .catch(err => { return [] }); 
    }

    onFeeSheetAgentSelectionChanged(e:any) {
        this.notSelectedManually = false;
    }

    onFeeSheetSelectionChanged(e: any) {
        this.notSelectedManually = false;
        let selected = e.selectedItem;

        if (selected) {
            this.selectedSheetNameFeeSheetId = selected.FeeSheetId;
        }
    }

    onAddPhaseType(e:any): void {
        this.feeSheetRow = this.feeSheetRowDefaultValue();
        this.feeSheetRowType = FeeSheetRowTypeEnum.Phase;
        this.feeSheetRowModalType = FeeSheetModalType.Add;        

        let selected = this.PhaseFeeSheetRows.map((item: FeeSheetRowDto) => {
            let res = item.PhaseAliasId || item.PhaseTypeId || 0;

            return res;
        });

        this.selectedPhasesInfraction = selected;
        this.showFeeSheetRowDialog = true;
    }

    onAddInfraction(e:any): void {
        this.feeSheetRow = this.feeSheetRowDefaultValue();
        this.feeSheetRowType = FeeSheetRowTypeEnum.Infraction;
        this.feeSheetRowModalType = FeeSheetModalType.Add;        

        let selected = this.InfractionFeeSheetRows.map((item: FeeSheetRowDto) => {
            let res = item.InfractionTypeId || '';

            return res;
        });

        this.selectedPhasesInfraction = selected;
        this.showFeeSheetRowDialog = true;
    }

    setAttr(name: string, value: any) : any {
        return Object.keys(this.$attrs).indexOf(name) > -1 ? this.$attrs[name] : value;
    }

    hidingFeeSheetRowDialog(e: FeeSheetRowDto | undefined): void {
        if(e) {
            let cloned = _.clone(e);
            this.processCapDisplay(cloned);

            if(this.feeSheetRowIndex == undefined) {

                if(this.feeSheetRowType === FeeSheetRowTypeEnum.Phase) {
                    this.PhaseFeeSheetRows.push(cloned);
                }
                else {
                    this.InfractionFeeSheetRows.push(cloned);
                }                
            }
            else {
                if(this.feeSheetRowType === FeeSheetRowTypeEnum.Phase){
                    let phaseRow = this.PhaseFeeSheetRows[this.feeSheetRowIndex];

                    phaseRow.CapDisplay = cloned.CapDisplay;
                    phaseRow.Description = cloned.Description;
                    phaseRow.FeeSheetRules = cloned.FeeSheetRules;
                    phaseRow.DeletedFeeSheetRules = cloned.DeletedFeeSheetRules;
                }
                else {
                    let infractionRow = this.InfractionFeeSheetRows[this.feeSheetRowIndex];

                    infractionRow.CapDisplay = cloned.CapDisplay;
                    infractionRow.Description = cloned.Description;
                    infractionRow.FeeSheetRules = cloned.FeeSheetRules;
                    infractionRow.DeletedFeeSheetRules = cloned.DeletedFeeSheetRules;
                }              
            }
        }

        this.showFeeSheetRowDialog = false;
        this.feeSheetRowIndex = undefined;
    }

    processCapDisplay(feeSheetRow: FeeSheetRowDto, isForParent: boolean = false) : void {
        this.feeSheetRow.FeeSheetRules = feeSheetRow.FeeSheetRules.sort(FeeSheetRulesSortFunction);                
        feeSheetRow.CapDisplay = '';
        let parentRow = (!isForParent && this.feeSheetFor == FeeSheetModalFor.Agent)  ? 
                    (feeSheetRow.InfractionTypeId ? _.find(this.parentFeeSheetRows, x => x.InfractionTypeId == feeSheetRow.InfractionTypeId) :
                     (feeSheetRow.PhaseTypeId != undefined ? _.find(this.parentFeeSheetRows, x => x.PhaseTypeId == feeSheetRow.PhaseTypeId) :
                     _.find(this.parentFeeSheetRows, x => x.PhaseAliasId == feeSheetRow.PhaseAliasId)))
                    : undefined;

        _.forEach(feeSheetRow.FeeSheetRules, (item: FeeSheetRuleDto) => {
            
            let details = '';

            let countryDetail = '';
            if(item.CountryId && item.CountryId > 0) {
                let ctryDetail = _.find(this.countryList, (cntry : CountryDto) => cntry.CountryId === item.CountryId);

                countryDetail = ctryDetail ? ctryDetail.CountryCode : '';
            }

            //to be implemented
            let levelDetail = '';

            if(item.Level != undefined) {                
                levelDetail = this.getLevelDetail(item.Level);
            }

            let capTargetDetail = this.forCapDisplayDetail(feeSheetRow, item);
           
            details =`${countryDetail} ${levelDetail} ${capTargetDetail ? capTargetDetail + ':' : ''}
            ${this.$options.filters ? this.$options.filters.currency(item.Amount) : item.Amount}`;

            if(parentRow) {
                let parentRule = _.filter(parentRow.FeeSheetRules, x => (x.CountryId || 0) == (item.CountryId || 0 ) 
                                    && x.Level == item.Level);
                if(!parentRule || parentRule.length == 0) {
                    feeSheetRow.CapDisplay = `${feeSheetRow.CapDisplay}<p><span style="color: blue;">${details}</span></p>`;
                }
                else {
                    let hasSameRule = _.find(parentRule, i => i.CapAmount == item.CapAmount &&
                        i.TargetAmount == item.TargetAmount && i.Level == item.Level)
                    if(!hasSameRule) {
                            feeSheetRow.CapDisplay = `${feeSheetRow.CapDisplay}<p><span style="color: orange;">${details}</span></p>`;
                    }
                    else {
                        feeSheetRow.CapDisplay = `${feeSheetRow.CapDisplay}<p><span>${details}</span></p>`;
                    }
                }
            }
            else{
                feeSheetRow.CapDisplay = `${feeSheetRow.CapDisplay}<p><span>${details}</span></p>`;
            }
            
        });

    }

    forCapDisplayDetail(feeSheetRow: FeeSheetRowDto, item: FeeSheetRuleDto) : string {
        let result = '';
    
        let hasTarget = _.find(feeSheetRow.FeeSheetRules, 
            (item : FeeSheetRuleDto) => item.Type === FeeSheetRuleTypeEnum.Target || item.TargetAmount != null);

       
        if(item.Type) {
            result = hasTarget ? item.Type : '';

            if(item.Type === FeeSheetRuleTypeEnum.Cap) {
                item.CapAmount = item.Amount;
                item.TargetAmount = undefined;
            }
            else {
                item.TargetAmount = item.Amount;
                item.CapAmount = undefined;
            }
        }
        else {
            //since 0 value also a false value
            if(item.CapAmount != null) {
                result = hasTarget ? FeeSheetRuleTypeEnum.Cap : '';
                item.Amount = item.CapAmount;
                item.Type = FeeSheetRuleTypeEnum.Cap;
            }
            else if(item.TargetAmount != null) {
                result = hasTarget ? FeeSheetRuleTypeEnum.Target : '';
                item.Amount = item.TargetAmount;
                item.Type = FeeSheetRuleTypeEnum.Target;
            }
        }  

        if(!item.Level) {
            item.Level = FeeSheetRuleLevelEnum.NA;
        }
        
        return result;
    }

    getLevelDetail(level: FeeSheetRuleLevelEnum) {
        switch(level) {
            case FeeSheetRuleLevelEnum.NA:
                return FeeSheetRuleLevelNameEnum.NA;
            case FeeSheetRuleLevelEnum.Level1:
                return FeeSheetRuleLevelNameEnum.Level1;
            case FeeSheetRuleLevelEnum.Level2:
                return FeeSheetRuleLevelNameEnum.Level2;                        
            case FeeSheetRuleLevelEnum.Level3:
                return FeeSheetRuleLevelNameEnum.Level3;
            case FeeSheetRuleLevelEnum.Level4:
                return FeeSheetRuleLevelNameEnum.Level4;
            case FeeSheetRuleLevelEnum.Level5:
                return FeeSheetRuleLevelNameEnum.Level5;
            case FeeSheetRuleLevelEnum.Level6:
                return FeeSheetRuleLevelNameEnum.Level6;
            case FeeSheetRuleLevelEnum.Level7:
                return FeeSheetRuleLevelNameEnum.Level7;
            case FeeSheetRuleLevelEnum.Level8:
                return FeeSheetRuleLevelNameEnum.Level8;
            case FeeSheetRuleLevelEnum.Level9:
                return FeeSheetRuleLevelNameEnum.Level9;
            case FeeSheetRuleLevelEnum.Level10:
                return FeeSheetRuleLevelNameEnum.Level10;
        }
    }

    feeSheetRowEditBtnClicked(data:any) : void {
        this.feeSheetRowType = FeeSheetRowTypeEnum.Phase;
        this.processDataForEdit(data);
    }

    feeSheetRowInfractionEditBtnClicked(data:any) : void {
        this.feeSheetRowType = FeeSheetRowTypeEnum.Infraction;   
        this.processDataForEdit(data);
    }

    feeSheetRowInfractionRemoveBtnClicked(data:any, phaseOrInfraction: string) : void {
        if(!this.feeSheet.DeletedFeeSheetRows) {
            this.feeSheet.DeletedFeeSheetRows = [];
        }

        if(data.data.FeeSheetRowId != "00000000-0000-0000-0000-000000000000") {
            this.feeSheet.DeletedFeeSheetRows.push(data.data);
        }

        if(phaseOrInfraction === FeeSheetRowTypeEnum.Phase) {
            this.PhaseFeeSheetRows.splice(data.rowIndex, 1);
        }
        else {
            this.InfractionFeeSheetRows.splice(data.rowIndex, 1);
        }
    }

    processDataForEdit(data: any): void {
        this.feeSheetRowIndex = data.rowIndex;

        this.feeSheetRow = _.cloneDeep(data.data);

        this.feeSheetRowModalType = FeeSheetModalType.Update;
        this.showFeeSheetRowDialog = true;
        this.selectedPhasesInfraction = [];
    }
    validationForm: any;

    private async processSave() {        
        let payload = _.clone(this.feeSheet);

        if (payload.FilingTypes.includes(-1)) {
            payload.FilingTypes = [];
        }

        this.isLoading = true;
        try {
            if(this.feeSheet.ReceiptFileName != null && this.feeSheet.ReceiptFileName.toLowerCase().endsWith(".pdf") && this.feeSheet.ReceiptFileId == null) {
                let fileDetails = await this.processFile()
                if(fileDetails && fileDetails.Success) {
                    payload.ReceiptFileId = fileDetails.Data.UploadedFiles[0].FileId;
                }
                else {
                    throw new Error("Failed to upload file");
                }
            }
        }
        catch {
            notify('Failed to upload file', 'error');
            payload.ReceiptFileName = this.originalFileName;
            payload.ReceiptFileId = this.originalFileId;
        }
        
        payload.FeeSheetRows = _.concat(this.PhaseFeeSheetRows, this.InfractionFeeSheetRows);

        _.forEach(payload.FeeSheetRows, (fr : FeeSheetRowDto) => {
            _.forEach(fr.FeeSheetRules, (item : FeeSheetRuleDto) => {
                if(!item.CountryId && item.CountryId === 0) {
                    item.CountryId = undefined;
                }
            });
        });

        if(payload.FeeSheetId != "00000000-0000-0000-0000-000000000000") {
            this.feeSheetsService.updateFeeSheetRecord(payload)
                .then(response => {
                    notify(`${payload.FeeSheetName} successfully saved`, 'success', 4000);
                    this.hidingModal(true);
                })
                .catch(err => {
                    alert('An error occurred saving the fee sheet.', 'Error');
                });
        }
        else {
            if(!this.isClientFor) {
                    _.forEach(payload.FeeSheetRows, (item: FeeSheetRowDto) => {
                        item.FeeSheetRowId = "00000000-0000-0000-0000-000000000000";

                    _.forEach(item.FeeSheetRules, (fsr : FeeSheetRuleDto) => {
                        fsr.FeeSheetRuleId = "00000000-0000-0000-0000-000000000000";
                    });
                })
            }

            this.feeSheetsService.create(payload)
                .then(response => {
                    notify(`${payload.FeeSheetName} successfully saved`, 'success', 4000);
                    this.hidingModal(true);
                })
                .catch(err => {
                    alert('An error occurred saving the fee sheet.', 'Error');
                });
        }
        this.isLoading = false;
    }
    
    private save(e: any): void {        
        if (this.showFeeSheetRowDialog) {
            return;
        }        

        this.validationForm = this.dxForm.validate();

        if (this.validationForm.status === 'pending') {
          this.validationForm.complete.then((response: any) => {
            if (response.isValid) {
              this.processSave()
            }
          });
        } else if (this.validationForm.isValid) {
          this.processSave()
        }
    }

    private hidingModal(updateData: boolean = false): void {
        this.$emit("hiding", updateData);
    }

    private cancel(): void {
        this.$emit("cancel");
    }
    displayUpdatedCells(e: any, rowStatus: FeeSheetRowStatusEnum, modifiedDetail : FeeSheetRowDetailEnum) {
        if(e.row.data.RowInfo && 
           e.row.data.RowInfo.Status == rowStatus &&
           e.row.data.RowInfo.ModifiedDetails &&
           e.row.data.RowInfo.ModifiedDetails.includes(modifiedDetail)) {
                e.cellElement.style['border'] = "solid 2px orange";
                e.cellElement.style['box-shadow'] = "inset 0px 0px 3px rgba(0,0,0,0.5)";
            }
        }
    onRowPrepared(e:any) {
        if(e.rowType === 'data') {
            e.rowElement.style.height = "50px"; 
        }

        if(e.rowType === 'data' && this.feeSheetFor === FeeSheetModalFor.Agent) {
            var hasParent = e.data.InfractionTypeId ? _.find(this.parentFeeSheetRows, x=> x.InfractionTypeId == e.data.InfractionTypeId) :
                            (e.data.PhaseTypeId != undefined ? _.find(this.parentFeeSheetRows, x=> x.PhaseTypeId == e.data.PhaseTypeId) :
                            _.find(this.parentFeeSheetRows, x=> x.PhaseAliasId == e.data.PhaseAliasId));

            if(!hasParent && ((!e.data.RowInfo && e.data.FeeSheetRowId == "00000000-0000-0000-0000-000000000000") ||
                e.data.RowInfo.Status == FeeSheetRowStatusEnum.New)) {
                e.rowElement.style['background'] = "rgb(219, 239, 250)";
                e.rowElement.style['box-shadow'] = "0px 0px 3px rgba(0,0,0,0.5)";
            }
        }
    }

    onCellPrepared(e: any) {
        if(e.rowType === 'data' && this.feeSheetFor === FeeSheetModalFor.Agent) {
            this.processExplicitModificationDetail(e.row.data);
            if(e.column.dataField === 'Description') {
                this.displayUpdatedCells(e, FeeSheetRowStatusEnum.Modified, FeeSheetRowDetailEnum.Description);
            }

            if(e.column.dataField === 'CapDisplay'){
                this.displayUpdatedCells(e, FeeSheetRowStatusEnum.Modified, FeeSheetRowDetailEnum.Rule);
            }

            if(e.column.dataField === 'Signed'){
                this.displayUpdatedCells(e, FeeSheetRowStatusEnum.Modified, FeeSheetRowDetailEnum.Signed);
            }
        }
  }

    processExplicitModificationDetail(data: FeeSheetRowDto) {
        let parentRow = data.InfractionTypeId ? 
                _.find(this.parentFeeSheetRows, item => item.InfractionTypeId == data.InfractionTypeId) :
                (data.PhaseTypeId != undefined ?
                _.find(this.parentFeeSheetRows, item => item.PhaseTypeId == data.PhaseTypeId) :
                _.find(this.parentFeeSheetRows, item =>  item.PhaseAliasId == data.PhaseAliasId));
        if(!data.RowInfo) {
            data.RowInfo = {
                Status : FeeSheetRowStatusEnum.UnModified,
                ModifiedDetails: []
            }
        }
        if(parentRow) {
            let hasModified = false;            

            let agentDescription = data.Description
                .replaceAll("</p><br><p", "</p>\n\n<p")
                .replaceAll("</p><p", "</p>\n<p")
                .replaceAll(/(<([^>]+)>)/ig, '');

            let clientDescription = parentRow.Description
                .replaceAll("</p><br><p", "</p>\n\n<p")
                .replaceAll("</p><p", "</p>\n<p")
                .replaceAll(/(<([^>]+)>)/ig, '');              

            if(clientDescription.localeCompare(agentDescription, 'en', {sensitivity: 'base' }) != 0) {
                hasModified= true;
                if(!data.RowInfo.ModifiedDetails.includes(FeeSheetRowDetailEnum.Description)) {
                    data.RowInfo.ModifiedDetails.push(FeeSheetRowDetailEnum.Description);
                }
                
            }
            else{
                var toRemove = data.RowInfo.ModifiedDetails.indexOf(FeeSheetRowDetailEnum.Description);
                if(toRemove != -1) {
                    data.RowInfo.ModifiedDetails.splice(toRemove, 1);
                }
            }
            if(parentRow.Signed != data.Signed) {
                hasModified= true;
                if(!data.RowInfo.ModifiedDetails.includes(FeeSheetRowDetailEnum.Signed)) {
                    data.RowInfo.ModifiedDetails.push(FeeSheetRowDetailEnum.Signed);
                }
            }
            else{
                var toRemove = data.RowInfo.ModifiedDetails.indexOf(FeeSheetRowDetailEnum.Signed);
                if(toRemove != -1) {
                    data.RowInfo.ModifiedDetails.splice(toRemove, 1);
                }
            }

            var rules = parentRow ? parentRow.FeeSheetRules : [];
            if(!_.every(data.FeeSheetRules, item => _.find(rules, x => x.TargetAmount == item.TargetAmount &&
            x.CapAmount == item.CapAmount && x.Level == item.Level && (x.CountryId || 0) == item.CountryId) != undefined) ||
            !_.every(rules, item => _.find(data.FeeSheetRules, x => x.TargetAmount == item.TargetAmount &&
            x.CapAmount == item.CapAmount && x.Level == item.Level && x.CountryId == (item.CountryId || 0)) != undefined)) {
                hasModified= true;
                if(!data.RowInfo.ModifiedDetails.includes(FeeSheetRowDetailEnum.Rule)) {
                    data.RowInfo.ModifiedDetails.push(FeeSheetRowDetailEnum.Rule);
                }
            }
            else {
                var toRemove = data.RowInfo.ModifiedDetails.indexOf(FeeSheetRowDetailEnum.Rule);
                if(toRemove != -1) {
                    data.RowInfo.ModifiedDetails.splice(toRemove, 1);
                }
            }
            
            if(hasModified) {
                data.RowInfo.Status = FeeSheetRowStatusEnum.Modified;
            }
            else {
                data.RowInfo.Status = FeeSheetRowStatusEnum.UnModified;
            }
        }
        else {
            data.RowInfo.Status = FeeSheetRowStatusEnum.New;
        }
  }
  isModified(rowInfo: any) {
      if(rowInfo && rowInfo.Status == FeeSheetRowStatusEnum.Modified) {
          return false;
      }
      return true;
  }
  isForAgent() {
      return this.feeSheetFor === FeeSheetModalFor.Agent ? true: false;
  }
  onParentFeeSheetRowView(data: FeeSheetRowDto, phaseOrInfraction: FeeSheetRowTypeEnum) {
      if(phaseOrInfraction == FeeSheetRowTypeEnum.Phase) {
        var phaseOrMulti = data.PhaseTypeId != undefined ? _.find(this.parentFeeSheetRows, item => item.PhaseTypeId == data.PhaseTypeId) :
                            _.find(this.parentFeeSheetRows, item => item.PhaseAliasId == data.PhaseAliasId);
        if(phaseOrMulti) {
            this.parentFeeSheetRowToView = {
                Description: phaseOrMulti.Description,
                PhaseOrInfractionName: phaseOrMulti.PhaseType ? phaseOrMulti.PhaseType.PhaseName : 
                    (phaseOrMulti.PhaseAlias ? phaseOrMulti.PhaseAlias.Name: ""),
                Signed: phaseOrMulti.Signed,
                CapDisplay: phaseOrMulti.CapDisplay,
                FeeSheetRowType: FeeSheetRowTypeEnum.Phase
            };
        }
      }
      else {
        var infraction = _.find(this.parentFeeSheetRows, item => item.InfractionTypeId == data.InfractionTypeId);
        if(infraction) {
            this.parentFeeSheetRowToView = {
                Description: infraction.Description,
                PhaseOrInfractionName: infraction.InfractionType ? infraction.InfractionType.Name : "",
                Signed: infraction.Signed,
                CapDisplay: infraction.CapDisplay,
                FeeSheetRowType: FeeSheetRowTypeEnum.Infraction
            };
        }
      }

      this.showParentFeeSheetRowDetail = true;
  }
  hidingParentFeeSheetRow(){
      this.showParentFeeSheetRowDetail = false;
      this.parentFeeSheetRowToView =  {
        Description: "",
        PhaseOrInfractionName: "",
        Signed: false,
        CapDisplay: "",
        FeeSheetRowType: FeeSheetRowTypeEnum.Phase
    };
  }
     private openNotes(data: any) {
        this.selectedfeeSheetRowNotes = data.data;
        this.showFeeSheetNotes=true;
    }

    private get feeSheetNotesTitle() {
        if(!this.selectedfeeSheetRowNotes) {
            return "";
        }
        
        if(this.selectedfeeSheetRowNotes.PhaseType) {
            return `${this.selectedfeeSheetRowNotes.PhaseType.PhaseName} Notes`;
        }

        if(this.selectedfeeSheetRowNotes.InfractionType) {
            return `${this.selectedfeeSheetRowNotes.InfractionType.Name} Notes`;
        }
        
        return "";
    }

    private getNotesClass(row:FeeSheetRowDto) {
        let defaultClass="notes-button";
        if(row.UserNotes) {
            return "notes-button has-notes";
        }
        else {
            return "notes-button";
        }
    }

    private fileChange() {
        let inputElement: any = this.$refs.fileReceipt;
        if(inputElement.files.length && inputElement.files[0].name.toLowerCase().endsWith(".pdf")) {
            this.selectedFile = inputElement.files[0];
            this.feeSheet.ReceiptFileName = inputElement.files[0].name
            this.feeSheet.ReceiptFileId = null;
            if(this.PhaseFeeSheetRows.find(x=>!x.Signed) || this.InfractionFeeSheetRows.find(x=>!x.Signed)) {
                let buttons: Array<any> = [
                    { text: 'Yes', onClick: (event: any) => { return true } },
                    { text: 'No', onClick: (event: any) => { return false } }
                ];

                let message = `<span style="text-align: center">Would you like to mark all of the rules on this sheet as 'signed'?</span>`;
                let title = `Sign Fee Sheet`;
                dialog.custom({messageHtml: message, title: title, buttons: buttons}).show().then((x: boolean) =>{
                    if(x) {
                        this.PhaseFeeSheetRows.filter(x=>!x.Signed).forEach(x=>x.Signed = true);
                        this.InfractionFeeSheetRows.filter(x=>!x.Signed).forEach(x=>x.Signed = true);
                    }
                })
            }
        }
        else {
            this.feeSheet.ReceiptFileName = null;
        }
    }

    private onSelection(event: any) {        
        this.feeSheet.LastSentDate = event.value;
    }

    private resetFile() {
        let buttons: Array<any> = [
            { text: 'OK', onClick: (event: any) => { return true } },
            { text: 'Cancel', onClick: (event: any) => { return false } }
        ];
        let inputElement: any = this.$refs.fileReceipt;

        let message = `<span style="text-align: center">Are you sure you would like to remove ${this.feeSheet.ReceiptFileName} from this sheet?</span>`
        let title = `Remove Receipt`

        dialog.custom({messageHtml: message, title: title, buttons: buttons}).show().then((x: boolean) =>{
            if(x) {
                inputElement.value = null;
                this.feeSheet.ReceiptFileId = null;
                this.feeSheet.ReceiptFileName = null;
                this.selectedFile = null;
            }
        })
    }

    private processFile() {
        if(this.feeSheet.ReceiptFileId == null && this.feeSheet.ReceiptFileName && this.feeSheet.ReceiptFileName.trim()) {
            var files : any[] = [{"filename": this.feeSheet.ReceiptFileName }];
            
            return this.fileService.uploadFiles({files: files}, this.selectedFile);
        }
        return Promise.resolve(null);
    }

    private downloadSheetUrl() {
        if(this.feeSheet.ReceiptFileId) {
            this.fileService.downloadFiles([this.feeSheet.ReceiptFileId])
            .then(result => {
                result.blob().then((b: any) => {
                    var fileURL = URL.createObjectURL(b);
                    window.open(fileURL);
                });
            })
        }
    }    

    private getDescriptionValue(data: any) {
        return data.Description.replaceAll(/(<([^>]+)>)/ig, '')
    }
}
